// 创建文件en/index.js
const en = {
    navbar:{
        home:"HOME",
        product:"PRODUCT",
    }
  }
  export default en